const { PAGE_NAMES, PAGE_TYPES } = require('../../../../../config/analytics');
const { analyticsEventBus, ANALYTICS_EVENTS } = require('../events');
const {
  getPreviousHitPageInfo,
  removeHitPageInfoFromSession,
  saveHitPageInfoIntoSession,
} = require('../helpers/hitPageInfo');

/**
 * Track the page name, type and url of the current page for GA in gaInfo global
 * variable.
 */
function trackPage() {
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.searchShown,
    saveHitPageInfoIntoSession
  );
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.searchHidden, () => {
    // Retrieve url, name and type from previous page_view_ecommerce event
    const hit = getPreviousHitPageInfo();
    gaInfo.pageName = hit.pageName;
    gaInfo.pageUrl = hit.pageUrl;
    gaInfo.pageType = hit.pageType;
    removeHitPageInfoFromSession();
  });
  // Empty search is a new independent page
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.searchReturnedNoResults, () => {
    gaInfo.pageName = PAGE_NAMES.search;
    gaInfo.pageType = PAGE_TYPES.search;
  });
  // Succesful search can be another independent page
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.searchReturnedResults,
    ({ isPageView }) => {
      if (isPageView) {
        gaInfo.pageName = PAGE_NAMES.search;
        gaInfo.pageType = PAGE_TYPES.search;
      }
    }
  );
  // User dynamic navigation
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.pageLoadedDynamically,
    (payload) => {
      gaInfo.pageUrl = window.location.href;
      gaInfo.pageType = payload.pageType;
      gaInfo.pageName = payload.pageTitle;
    }
  );
}

/**
 * Begin the tracking for gaInfo related data
 */
function beginTracking() {
  trackPage();
}

module.exports = {
  beginTracking,
};
